/**
 * Figma "Top Bar" (e.g. 3362:37116, 5911:55875, 2583:1064): one 54-high bar on every screen, 15 in
 * from either side, with the avatar or LOG IN, the wallet and the buttons all centred on it. It
 * starts 16 under the header's top edge, the same on Home and on every other screen.
 */
export const HEADER_BAR = { top: 16, height: 54, side: 15 } as const;

/** The bell and settings buttons, 44 wide and 10 apart, at the bar's right end. */
export const HEADER_ACTIONS_WIDTH = 44 + 10 + 44;
/** The wallet stops this far before the buttons. */
export const HEADER_WALLET_GAP = 10;

/**
 * Figma "Pill / Daily Missions" and "Pill / Free Chips": 126x48 on the 390 frame, 15 in from either
 * side, their top edge 80 under the header's own top - on Home that is the Play Now art's top
 * edge (Hero, 3362:37148). Every screen draws the same pair there, scaled with the frame.
 */
export const HEADER_PILL = { width: 126, height: 48, top: 80, side: 15 } as const;
export const DESIGN_FRAME_WIDTH = 390;

/** How much the pills grow with the screen; past 1.15 they stop, as Home's hero does. */
export const getHeaderPillScale = (viewportWidth: number) =>
	Math.min(viewportWidth / DESIGN_FRAME_WIDTH, 1.15);
